export const TODO_STATUS = {
  OPEN: "open",
  COMPLETED: "completed",
};

export const TODO_PRIORITY = {
  NONE: "None",
  LOW: "Low",
  MEDIUM: "medium",
  HIGH: "High",
};
